import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';
import { SUPPORT_EMAIL } from '../../marketing/links';
import { mkTrack } from '../../marketing/track';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer {...props} className={classes}>
      <div className='container'>
        <div
          className={classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}
        >
          <div className='footer-top space-between text-xxs'>
            <Logo className='mk-logo--sm' />
            <FooterSocial />
          </div>
          <div className='footer-bottom space-between text-xxs invert-order-desktop'>
            <FooterNav />
            <div className='footer-copyright mk-footer-legal'>
              <p className='mk-footer-legal__line'>
                © {new Date().getFullYear()} eudaiTec GmbH, Berlin · Support:{' '}
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  onClick={() => mkTrack('outbound_click', 'support_email:footer')}
                >
                  {SUPPORT_EMAIL}
                </a>
              </p>
              <p className='mk-micro mk-footer-legal__tm'>
                App Store is a service mark of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
